import { Action, ThunkDispatch } from '@reduxjs/toolkit'
import { showAlert } from 'app/app/(client)/redux/features/notification/alert-slice'
import { apiErrorAlert, sessionExpiredProps } from 'app/app/(client)/redux/features/notification/modal-state'
import { RootState } from 'app/app/(client)/redux/Store'
import { ApiError, AppErrorType } from '../common-error-utils'
import { notify } from 'app/app/bugsnag/bugsnag.client'
import { login, logOut } from 'app/app/api/auth/auth-actions'

export const handleUIError = (
  dispatch: ThunkDispatch<RootState, unknown, Action>,
  apiError: ApiError,
  showGenericAlert: boolean = true
) => {
  // Console log complete error details in a single formatted message
  console.error(
    ` Handled Error Details:\n` +
      `  Name: ${apiError.name}\n` +
      `  Type: ${apiError.type || 'N/A'}\n` +
      `  Message: ${apiError.message}\n` +
      `  Status: ${apiError.status || 'N/A'}\n` +
      `  Timestamp: ${apiError.timestamp}\n` +
      `  Stack: ${apiError.stack || 'No stack trace available'}`
  )

  notify(apiError)
  if (apiError.message.includes(AppErrorType.INVALID_SESSION)) {
    dispatch(
      showAlert(
        sessionExpiredProps(dispatch, async () => {
          try {
            await logOut()
            await login()
          } catch (error) {
            dispatch(
              showAlert({
                ...apiErrorAlert(dispatch, {
                  type: AppErrorType.UnknownError,
                  message: (error as Error).message,
                  name: ''
                })
              })
            )
          }
        })
      )
    )
    return
  }
  if (showGenericAlert) {
    dispatch(showAlert({ ...apiErrorAlert(dispatch, apiError) }))
  }
}
